// errorMessages.js
export default {
  en: {
    required: "cannot be blank",
    must_be_checked: "must be checked",
    must_be_selected: "No option selected. please select an option.",
    not_blank: "cannot be blank",
    numeric: "must be a whole number",
    greater_than_zero: "must be a positive number",
    float: "must be a numeric value",
    max_length: "exceeds maximum length __first__",
    decimal_places: "must be a number with up to {param_0} decimal places",
    date: "must be a valid date format",
    datetime: "must be a valid date and time",
    date_time: "must be a valid date and time",
    min_limit: "must be at least __first__",
    max_limit: "cannot exceed __first__",
    not_before_today: "cannot be in the past",
    not_after_today: "cannot be in the future",
    regex: "has invalid {param_1}",
    regex_numeric8: "STO ID incorrect. Please check the STO ID or contact the trainer.",
    regex_email: "Please enter a valid email format.",
    postal_code_format: "has invalid postal code",
    email_format: "has invalid email address",
    phone_format: "has invalid phone number",
    required_if_selected: "cannot be blank",
    resource_required_error: "cannot be blank while the current exam type is selected.",
    accommodation_other_error: "cannot be blank when the other check box is selected.",
    coordinates: "must be coordinates, e.g. 45,100",
    image: "Invalid file type",
    size: "File is greater than 2 MB",
    in_the_past: "cannot be in the past",
    not_before_start_time: "cannot be equal to or earlier than the start time",
    start_date_before_end_date: "must be earlier or the same as the end date",
    greater_than: "must be greater than or equal to",
    less_than: "must be less than or equal to {param_0}",
    at_least_one_checked: "at least one option must be selected",
    required_if_checked: "must be checked if  {param_1} is checked.",
    alphabet_or_white_space: "only allows alphabetic characters and spaces.",
    time_not_in_past: "cannot be in the past",
    date_not_in_past: "cannot be in the past",
    between: "must be greater than or equal to {param_0} and less than or equal to {param_1}.",
    date_not_after_end_date: "cannot be before end date."
  },
  fr: {
    required: "ne peut pas être vide",
    must_be_checked: "doit être vérifié",
    not_blank: "ne peut pas être vide",
    must_be_selected: "aucune option sélectionnée. veuillez sélectionner une option",
    numeric: "doit être un nombre entier",
    greater_than_zero: "doit être un nombre positif",
    float: "doit être une valeur numérique",
    max_length: "cépasse la longueur maximale __first__",
    decimal_places: "doit être un nombre avec jusqu'à {param_0} décimales",
    date: "doit être un format de date valide",
    required_if: "requis si la valeur __first__ est complétée",
    datetime: "la date et l'heure doivent être valides",
    date_time: "la date et l'heure doivent être valides",
    min_limit: "doit être au moins __first__",
    max_limit: "ne peut pas dépasser __first__",
    regex: "a un {param_1} invalide",
    regex_numeric8: "ID MSO incorrect. Veuillez vérifier l’ID de MSO ou communiquer avec le formateur.",
    regex_email: "Veuillez entrer un format de courriel valide.",
    postal_code_format: "a un code postal invalide",
    email_format: "a un adresse courriel invalide",
    phone_format: "a un numéro de téléphone invalide",
    required_if_selected: "ne peut pas être vide",
    in_the_past: "ne peut pas être dans le passé",
    not_before_start_time: "ne peut être égale ou antérieure à l'heure de début",
    resource_required_error: "ne peut pas être vide",
    accommodation_other_error: "French text needed",
    coordinates: "doit être des coordonnées, par ex. 45,100",
    image: "Type de fichier invalide",
    size: "Le fichier fait plus de 2 Mo",
    start_date_before_end_date: "doit être antérieure ou la même que la date de fin",
    greater_than: "​doit être supérieur ou égal à",
    less_than: "doit être inférieur ou égal à {param_0}",
    at_least_one_checked: "au moins une option doit être sélectionnée.",
    required_if_checked: "doit être vérifié {param_1} est vérifié.",
    alphabet_or_white_space: "only allows alphabetic characters and spaces.",
    time_not_in_past: "ne peut pas être dans le passé ",
    date_not_in_past: "ne peut pas être dans le passé",
    between: "doit être supérieur ou égal à {param_0} et inférieur ou égal à {param_1}.",
    date_not_after_end_date: "ne peut pas être avant la date de fin."
  }
}